<div class="mb-4">
    <button class="btn new-travel" type="button" (click)="createSimpleTravel()">{{'simple-travel-form.label.newTravel' | translate}}</button>
    <button class="btn save-travel" [disabled]="!productForm.valid" (click)="saveTravel()">{{'simple-travel-form.label.saveTravel' | translate}}</button>
    <button class="btn copy-travel" type="button" (click)="copySimpleTravel()">{{'simple-travel-form.label.copyTravel' | translate}}</button>
    <button class="btn delete-travel" type="button" (click)="deleteSimpleTravel()">{{'simple-travel-form.label.deleteTravel' | translate}}</button>
    <button class="btn" (click)="reloadWindow()">{{'simple-travel-form.label.reloadTravel' | translate}}</button>
    <button class="btn" style="float: right;" [hidden]="!travel.active" [ngClass]="{btnActivated: travel.active, btnDeactivated: !travel.active}" (click)="setTravelStatus(travel)">{{'simple-travel-form.label.activate-yes' | translate}} </button>
    <button class="btn" style="float: right;" [hidden]="travel.active" [ngClass]="{btnActivated: travel.active, btnDeactivated: !travel.active}" (click)="setTravelStatus(travel)">{{'simple-travel-form.label.activate-no' | translate}}</button>
</div>
<form #productForm="ngForm" (ngSubmit)="onSubmit()" [ngClass]="{setZIndex: spinnerLoading}">
    <!-- <app-header>123333</app-header> -->
    <ng4-loader-bar [height]="'4px'"></ng4-loader-bar>

    <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-6">
            <div class="form-group row">
                <label for="travel-header-de_DE" class="col-sm-2 col-form-label gradient-effect">{{'simple-travel-form.label.header' | translate}}</label>
                <div class="col-sm-10">
                    <input [(ngModel)]="travel.header[defaultLanguage]" required name="travel.header.de_DE" type="text" class="form-control" id="travel-header-de_DE">
                </div>
            </div>

            <div class="form-group row">
                <label for="travel-subHeader-de_DE" class="col-sm-2 col-form-label gradient-effect">{{'simple-travel-form.label.subHeader' | translate}}</label>
                <div class="col-sm-10">
                    <input [(ngModel)]="travel.subHeader[defaultLanguage]" name="travel.subHeader.de_DE" type="text" class="form-control" id="travel-subHeader-de_DE">
                </div>
            </div>

            <div class="form-group row">
                <label for="travel-subText1-de_DE" class="col-sm-2 col-form-label gradient-effect">{{'simple-travel-form.label.subText1' | translate}}</label>
                <div class="col-sm-10">
                    <input [(ngModel)]="travel.subText1[defaultLanguage]" name="travel.subText1.de_DE" type="text" class="form-control" id="travel-subText1-de_DE">
                </div>
            </div>

            <div class="form-group row" *ngIf="premium">
                <label for="travel-subText2-de_DE" class="col-sm-2 col-form-label gradient-effect">{{'simple-travel-form.label.subText2' | translate}}</label>
                <div class="col-sm-10">
                    <input [(ngModel)]="travel.subText2[defaultLanguage]" name="travel.subtext2.de_DE" type="text" class="form-control" id="travel-subText2-de_DE">
                </div>
            </div>

            <div *ngIf="textArrived">
                <div class="form-group row">
                    <label for="travel-shortText-de_DE" class="col-sm-2 col-form-label gradient-effect">{{'simple-travel-form.label.shortText' | translate}}</label>
                    <div class="col-sm-10">
                        <textarea b4aTinymce [(ngModel)]="travel.shortText[defaultLanguage]" [model]="travel.shortText[defaultLanguage]" (onEditorKeyup)="travel.shortText[defaultLanguage] = $event" name="travel.shortText.nl_NL" class="form-control" id="travel-shortText-de_DE" rows="6"></textarea>
                    </div>
                </div>

                <div class="form-group row" *ngIf="premium">
                    <label for="travel-longText-de_DE" class="col-sm-2 col-form-label gradient-effect">{{'simple-travel-form.label.longText' | translate}}</label>
                    <div class="col-sm-10">
                        <textarea b4aTinymce [(ngModel)]="travel.longText[defaultLanguage]" [model]="travel.longText[defaultLanguage]" (onEditorKeyup)="updateLongText($event)" name="travel-longText-de_DE" class="form-control" id="travel-longText-de_DE" rows="16"></textarea>
                    </div>
                </div>
            </div>
            <b4a-image-upload [enableUpload]="enableUpload" (travelResponse)="uploadedImageResponse($event)" (spinnerLoading)="spinnerLoadingFunction($event)" [showGallery]="showGallery" [travel]="travel" [premium]="premium"></b4a-image-upload>

        </div>

        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-6">
            <div class="container gradient-effect margin-devider">
                <div class="row">
                    <div class="col-sm-12 hover-sub-header" style="margin-bottom: 10px;">
                        <h1><b>{{'simple-travel-form.label.simpleTravel' | translate}}</b></h1>
                    </div>

                    <div class="col-sm-12 col-md-12 col-lg-6">

                        <div class="form-group row">
                            <label for="travel-offerWindowNumber" class="col-sm-8 col-form-label ">{{'simple-travel-form.label.offerWindowNum' | translate}}</label>
                            <div class="col-sm-4">
                                <div class="form-group">
                                    <select [(ngModel)]="travel.at" name="travel.at" type="number" class="form-control" id="travel.at">
                                  <option [ngValue]=null selected>{{'simple-travel-form.value.window.none' | translate}}</option>
                                  <option [ngValue]=1>1</option>
                                  <option [ngValue]=2>2</option>
                                  <option [ngValue]=3>3</option>
                                  <option [ngValue]=4>4</option>
                                </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-12 col-lg-6">

                        <div class="form-group row" *ngIf="!premium">
                            <label for="travel-category" class="col-sm-8 col-form-label">{{'simple-travel-form.label.category' | translate}}</label>
                            <div class="col-sm-4">
                                <select [(ngModel)]="travel.accommodation.category" name="travel.accommodation.category" type="number" class="form-control" id="travel.accommodation.category">
                                  <option [ngValue]=null selected>{{'simple-travel-form.value.category.none' | translate}}</option>
                                  <option [ngValue]=1>1</option>
                                  <option [ngValue]=2>2</option>
                                  <option [ngValue]=3>3</option>
                                  <option [ngValue]=4>4</option>
                                  <option [ngValue]=5>5</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12 col-md-12 col-lg-6" *ngIf="premium">
                        <div class="form-group row">
                            <label for="travel-hotelName" class="col-sm-3 col-form-label ">{{'simple-travel-form.label.hotel' | translate}}</label>
                            <div class="col-sm-9">
                                <input required [(ngModel)]="travel.accommodation.name" name="travel.accommodation.name" type="text" class="form-control" id="travel.accommodation.name">
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-12 col-lg-6">
                        <div class="form-group row" *ngIf="premium">
                            <label for="travel-category" class="col-sm-8 col-form-label">{{'simple-travel-form.label.category' | translate}}</label>
                            <div class="col-sm-4">
                                <select [(ngModel)]="travel.accommodation.category" name="travel.accommodation.category" type="number" class="form-control" id="travel.accommodation.category">
                                  <option [ngValue]=null selected>{{'simple-travel-form.value.category.none' | translate}}</option>
                                  <option [ngValue]=1>1</option>
                                  <option [ngValue]=2>2</option>
                                  <option [ngValue]=3>3</option>
                                  <option [ngValue]=4>4</option>
                                  <option [ngValue]=5>5</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-12 col-md-12 col-lg-6" *ngIf="premium">
                        <div class="form-group row">
                            <label for="travel-type" class="col-sm-3 col-form-label">{{'simple-travel-form.label.travelType' | translate}}</label>
                            <div class="col-sm-9">
                                <select [(ngModel)]="travel.type" required name="travel.type" class="form-control" id="travel-type">
                <!--<option value="">---</option>-->
                <!--<option *ngFor="let pT of productTypes" value="{{pT.code}}">{{pT.name}}</option>-->
                <option value="{{productTypeCode}}">{{productTypeName}}</option>
              </select>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-12 col-md-12 col-lg-6" *ngIf="premium">
                        <div class="form-group row">
                            <label for="travel-accommodation-boardType" class="col-sm-5 col-form-label">{{'simple-travel-form.label.boardType' | translate}}</label>
                            <div class="col-sm-7">
                                <select [ngModel]="travel.accommodation.boardType" (ngModelChange)="boardChanged($event);travel.accommodation.boardType=$event" required name="travel.accommodation.boardType" class="form-control" id="travel-accommodation-boardType">
                <option value="">---</option>
                <option *ngFor="let bT of selectedBoardTypes" [disabled]="!bT.selectable" value="{{bT.code}}">{{bT.short}} ({{bT.name}})</option>
              </select>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-12 col-md-12 col-lg-6">
                        <div class="form-group row">
                            <label for="travel-durVal" class="col-sm-8 col-form-label">{{'simple-travel-form.label.durValue' | translate}}</label>
                            <div class="col-sm-4">
                                <input [(ngModel)]="travel.durVal" required name="travel.durVal" type="number" class="form-control" id="travel-durVal">
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-12 col-md-12 col-lg-6">
                        <div class="form-group row" *ngIf="premium">
                            <label for="travel-accommodation-region" class="col-sm-5 col-form-label">{{'simple-travel-form.label.superRegion' | translate}}</label>
                            <div class="col-sm-7">
                                <select [(ngModel)]="travel.accommodation.superRegion" required (change)="getRegionForSuperRegion(travel.accommodation.superRegion, 'no')" name="travel.accommodation.superRegion" class="form-control" id="travel.accommodation.superRegion">
                <option value="">---</option>
                <option *ngFor="let reg of superRegions" value="{{reg.code}}">{{reg.name}}</option>
              </select>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="row">

                    <div class="col-sm-12 col-md-12 col-lg-6" *ngIf="premium">
                        <div class="form-group row">
                            <label for="travel-durVal" class="col-sm-5 col-form-label">{{'simple-travel-form.label.toAirport' | translate}}</label>
                            <div class="col-sm-7">
                                <select [(ngModel)]="travel.flight.toAirport" pattern=".{3,50}" (change)="disableSelectedAirports()" required name="travel.flight.toAirport" type="number" class="form-control" id="travel.flight.toAirport">
                <option value="">---</option>
                <option *ngFor="let aiport of airports" [ngValue]="aiport.code">{{aiport.name}}</option>
              </select>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-12 col-md-12 col-lg-6">
                        <div class="form-group row" *ngIf="premium">
                            <label for="travel-accommodation-region" class="col-sm-5 col-form-label">{{'simple-travel-form.label.region' | translate}}</label>
                            <div class="col-sm-7">
                                <select [(ngModel)]="travel.accommodation.region" required name="travel.accommodation.region" class="form-control" id="travel-accommodation-region">
                <option value="">---</option>
                <option *ngFor="let reg of regions" [ngValue]="reg.code">{{reg.name}}</option>
              </select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container gradient-effect margin-devider">
                <div class="row  hover-sub-header" title="{{'simple-travel-form.hint.add.date' | translate}}" (click)="addRooms()">
                    <div class="col-sm-10">
                        <h1><b>{{'simple-travel-form.label.dates' | translate}}</b></h1>
                    </div>
                    <div class="col-sm-2 text-right">
                        <button alt="" class="btn btn-sm"><i class="fa fa-plus"></i></button>
                    </div>
                </div>
                <br>
                <div class="row" *ngIf="roomsHeader">
                    <div class="col-sm-2">
                        <label>   {{'simple-travel-form.label.dates-start' | translate}}</label>
                    </div>
                    <div class="col-sm-1 ">

                    </div>
                    <div class="col-sm-2">
                        <label>{{'simple-travel-form.label.dates-end' | translate}} </label>
                    </div>
                    <div class="col-sm-2">
                        <label>{{'simple-travel-form.label.dates-roomType' | translate}} </label>
                    </div>
                    <div class="col-sm-2">
                        <label>{{'simple-travel-form.label.dates-price' | translate}} </label>
                    </div>
                    <div class="col-sm-1">
                        <label>{{'simple-travel-form.label.dates-active' | translate}} </label>
                    </div>
                    <div class="col-sm-2 ">

                    </div>

                </div>
                <b4a-product-simple-travel-form-room-types class="col-sm-12" *ngFor="let aux of roomTypeNumber; index as i" [disableDaysArray]="disableDaysArray" [day]="day" [month]="month" [year]="year" [lenghtOfRooms]="lenghtOfRooms" [minDateForOffer]="minDateForOffer"
                    (sendCopyToParent)="copyRooms($event)" (sendDisabledDatesArray)="sendDisabledDatesArray($event)" (sendValid)="roomFormValid($event)" (sendIdForDelete)="deleteRoom($event)" [durValue]="travel.durVal" [index]="i" [roomType]="aux" [roomTypes]="roomTypes"></b4a-product-simple-travel-form-room-types>
            </div>

            <div class="container gradient-effect margin-devider" *ngIf="premium">
                <div class="row hover-sub-header" title="{{'simple-travel-form.hint.add.airport' | translate}}" (click)="addAirports()">
                    <div class="col-sm-10">
                        <h1><b>{{'simple-travel-form.label.airport' | translate}}</b></h1>
                    </div>
                    <div class="col-sm-2 text-right">
                        <button alt="" class="btn btn-sm"><i class="fa fa-plus"></i></button>
                    </div>
                </div>
                <br/>
                <div class="row" *ngIf="airportsHeader">
                    <div class="col-sm-4 col-md-4">
                        <label>{{'simple-travel-form.label.airport-from' | translate}} </label>
                    </div>
                    <div class="col-sm-3 col-md-3">
                        <label>{{'simple-travel-form.label.airport-price' | translate}} </label>
                    </div>
                    <div class="col-sm-2 col-md-2">
                        &nbsp;
                    </div>
                    <div class="col-sm-1 col-md-1">
                        <label> {{'simple-travel-form.label.airport-active' | translate}}</label>
                    </div>
                    <div class="col-sm-1 col-md-1">

                    </div>
                </div>
                <b4a-product-simple-travel-form-airports class="col-sm-12" *ngFor="let flight of TempAirportsArray; index as i" (sendAirportIdForDelete)="deleteAirport($event)" (sendAirportCopyToParent)="copyAirportArray($event)" (sendValidAirport)="airportFormValid($event)"
                    [lenghtOfAirports]="lenghtOfAirports" [index]="i" [airports]="flight" (sendSelectableAirport)="setNewSelectableAirport($event)" [selectedAirportTypes]="selectedAirportTypes" [fromAirports]="fromAirports"></b4a-product-simple-travel-form-airports>
            </div>
            <div class="container gradient-effect margin-devider" *ngIf="premium">
                <div class="row  hover-sub-header" title="{{'simple-travel-form.hint.add.board' | translate}}" (click)="addBoardUpgrades()">
                    <div class="col-sm-10">
                        <h1><b>{{'simple-travel-form.label.board' | translate}}</b></h1>
                    </div>
                    <div class="col-sm-2 text-right">
                        <button alt="" class="btn btn-sm"><i class="fa fa-plus"></i></button>
                    </div>
                </div>
                <br/>
                <div class="row" *ngIf="boardsHeader">
                    <div class="col-sm-4">
                        <label> {{'simple-travel-form.label.board-upgrade' | translate}} </label>
                    </div>
                    <div class="col-sm-3">
                        <label>{{'simple-travel-form.label.board-price' | translate}} </label>
                    </div>
                    <div class="col-sm-2">
                    </div>
                    <div class="col-sm-1">
                        <label>{{'simple-travel-form.label.board-active' | translate}} </label>
                    </div>
                    <div class="col-sm-1">
                        &nbsp;
                    </div>

                </div>
                <b4a-product-simple-travel-form-board-upgrades class="col-sm-12" *ngFor="let board of TempBoardsArray; index as i" (sendBoardCopyToParent)="copyBoardArray($event)" (sendValidBoard)="boardFormValid($event)" (sendIdForDeleteBoard)="deleteBoardById($event)"
                    [lenghtOfBoards]="lenghtOfBoards" [index]="i" [boards]="board" (sendSelectableBoard)="setNewSelectableBoard($event)" [selectedBoardTypes]="selectedBoardTypes" [boardTypes]="boardTypes"></b4a-product-simple-travel-form-board-upgrades>
            </div>
            <br/>
        </div>
    </div>
</form>
<div class="spinner" *ngIf="spinnerLoading">
    <div class="centered">

        <img src="../../../assets/loading_spinner.gif">
        <p><b>{{'simple-travel-form.label.uploading' | translate}}</b></p>
    </div>
</div>



// WEBPACK FOOTER //
// ./src/app/product/simple-travel-form/simple-travel-form.component.html